import { createChatBotMessage } from 'react-chatbot-kit';
//import FlutterDashIcon from '@mui/icons-material/FlutterDash';
import Avatar from '@mui/material/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faUserTie } from '@fortawesome/free-solid-svg-icons';
import BotChatMessage from './BotChatMessage';
import BotChatUploadFile from './BotChatUploadFile.jsx';
import Loader from './Loader.jsx';

const botName = 'ISAMBot';
const botArchives = 'isam-chatbot-messages';
const config = {
    archiveName: botArchives,
    botName: botName,
    initialMessages: [
        createChatBotMessage(`Hi! I'm ${botName}. How can I help you today?`),
    ],

    customComponents: {
        // Define custom components here
        header: () => (
            <>  </>
        ),

        botAvatar: (props) => (
            <Avatar className="react-chatbot-kit-chat-bot-avatar" sx={{ backgroundColor: '#5ccc9d' }} >
                <FontAwesomeIcon icon={faHeadset} {...props}/>
            </Avatar>
        ),
        botChatMessage: BotChatMessage,
        userAvatar: (props) => (
            <Avatar className="react-chatbot-kit-chat-user-avatar" sx={{ backgroundColor: '#376B7E' }}>
                <FontAwesomeIcon icon={faUserTie} {...props}/>
            </Avatar>
        ),
    },
    customStyles: {
        botMessageBox: {
            backgroundColor: '#efefef',
            color: '#585858',
        },
        userMessageBox: {
            backgroundColor: '#376B7E',
        },
        chatButton: {
            backgroundColor: '#376B7E',
        },
    },
    state: {
        // Define initial state here
        uploadFile: '',
    },
    widgets: [
        // Define widgets here
        {
            widgetName: 'uploadFile',
            widgetFunc: (props) => <BotChatUploadFile {...props} />,
            mapStateToProps: ['uploadFile'],
            props: {},
        },
        {
            widgetName: 'thinking',
            widgetFunc: (props) => <Loader {...props} />,
            mapStateToProps: ['uploadFile'],
            props: {},
        }
    ],
};

export default config;
